import { Button, Modal } from 'antd';
import i18next from 'i18next';
import * as Moment from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DateRangeFilter } from 'src/common/components/table-filters/date-range-filter';
import { emptyTableModel, getDateFormat } from 'src/common/utils';
import { formatMessage } from 'src/core/services/http.service';
import { Query } from 'src/core/stores/data-store';
import { TableModel, TableView } from 'src/core/ui/collections/table';
import { container } from 'src/inversify.config';
import { ImportExportDevLogSummary, ImportExportDevLogsStore } from 'src/stores/dev-logs-store';

type Trace = {
  id: string;
  description: string;
};

const ExportImportDevLogsPage: FC = () => {
  const { t } = useTranslation();
  const [query, setQuery] = useState({
    searchQuery: '',
    orderBy: [{ field: 'Date', direction: 'Descending', useProfile: false }],
    skip: 0,
    take: 10,
  } as Query);

  const [traceModalVisible, setTraceModalVisible] = useState(false);
  const [selectedTrace, setSelectedTrace] = useState<Trace>();

  const logsStore = container.get(ImportExportDevLogsStore);
  const logsState = logsStore.state;

  useEffect(
    () => {
      logsStore.load(query);
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const tableModel = {
    query,
    columns: [
      {
        sortable: true,
        searchable: false,
        filter: <DateRangeFilter />,
        fiterField: 'Date',
        field: 'Date',
        title: t('Timestamp'),
        renderer: (data) => <span>{Moment.utc(data.date).local().locale(i18next.language).format(`${getDateFormat()}, hh:mm a`)}</span>,
      },
      {
        searchable: false,
        sortable: true,
        sortField: 'StatusCode',
        useProfile: true,
        field: 'StatusCode',
        title: t('StatusCode'),
        renderer: (data) => <span>{data.statusCode}</span>,
      },
      {
        searchable: true,
        field: 'message',
        title: t('Message'),
        renderer: (data) => <span>{data.message}</span>,
      },
      {
        sortable: false,
        searchable: false,
        field: 'Trace',
        title: t('Traces'),
        renderer: (data) => (
          <Button
            type="dashed"
            className="solid-button"
            onClick={() => {
              setSelectedTrace({
                description: data.trace,
                id: data.traceId,
              });
              setTraceModalVisible(true);
            }}
          >
            {t('ViewTrace')}
          </Button>
        ),
      },
    ],
    data: { ...logsState.value, isBusy: logsState.value.isBusy },
  } as TableModel<ImportExportDevLogSummary>;

  return (
    <>
      <TableView
        rowKey="id"
        canCreateNew={false}
        canDelete={false}
        canEdit={false}
        canSort
        onQueryChanged={(query: Query) => {
          setQuery(query);
          logsStore.load(query);
        }}
        onRefresh={() => logsStore.load(query)}
        model={logsState.errorMessage.value ? emptyTableModel : tableModel}
        error={logsState.errorMessage.value && formatMessage(logsState.errorMessage.value)}
      />
      <Modal
        width={600}
        title={
          <>
            {'Trace Id: '}
            <br />
            {selectedTrace?.id}
          </>
        }
        open={traceModalVisible}
        onOk={() => setTraceModalVisible(false)}
        onCancel={() => setTraceModalVisible(false)}
        cancelButtonProps={{ style: { visibility: 'hidden', display: 'none' } }}
      >
        <div style={{ height: '400px', overflow: 'scroll' }}>{selectedTrace?.description}</div>
      </Modal>
    </>
  );
};

export default ExportImportDevLogsPage;
